import React, { useState, useContext } from "react";
import { HouseContext } from "../../context/HouseContext";
import House from "../House/House";
import { Link } from "react-router-dom";
import { ImSpinner2 } from "react-icons/im";

const HouseList = () => {
  const { houses, loading } = useContext(HouseContext);
  const [visibleHouses, setVisibleHouses] = useState(6); // Mostrar 6 casas inicialmente

  const showMoreHouses = () => {
    setVisibleHouses((prevVisibleHouses) => prevVisibleHouses + 6);
  };

  if (loading) {
    return (
      <ImSpinner2 className="mx-auto animate-spin text-primary text-4xl my-[200px]" />
    );
  }

  if (loading || houses.length === 0) {
    return (
      <div className="flex flex-col justify-center items-center h-screen">
        <ImSpinner2 className="animate-spin text-primary text-5xl mb-4" />
        <h2 className="text-primary text-2xl ml-4">Cargando Propiedades...</h2>
      </div>
    );
  }

  // Verificar si no hay casas después de que `houses` ya tiene datos
  if (!loading && houses.length > 0 && houses.length < 1) {
    return (
      <div className="text-center text-3xl text-gray-400 my-[200px]">
        Lo sentimos, no hemos encontrado resultados
      </div>
    );
  }

  // Mostrar todas las propiedades; las vendidas/alquiladas van al final
  // (quedan visibles, en gris y con sello, como publicidad de operaciones cerradas)
  const isClosed = (house) =>
    house.state === "Vendido" || house.state === "Alquilado";
  const sortedHouses = [...houses].sort(
    (a, b) => isClosed(a) - isClosed(b)
  );

  return (
    <section className="mb-20">
      <div className="mx-auto max-w-[1360px] px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-14 justify-center">
          {sortedHouses.slice(0, visibleHouses).map((house, index) => (
            <Link to={`/propiedad/${house.id}`} key={index} className="block h-full">
              <House house={house} />
            </Link>
          ))}
        </div>
        {visibleHouses < houses.length && (
          <div className="text-center mt-8">
            <button
              onClick={showMoreHouses}
              className="bg-primary text-white px-4 py-2 rounded hover:opacity-80"
            >
              Ver más Propiedades
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default HouseList;
